import { render, staticRenderFns } from "./ForgotPassword.auth.vue?vue&type=template&id=22844657&scoped=true&"
import script from "./ForgotPassword.auth.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.auth.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.auth.vue?vue&type=style&index=0&id=22844657&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22844657",
  null
  
)

export default component.exports